import { render } from "./EditSkill.vue?vue&type=template&id=821c88a0"
import script from "./EditSkill.vue?vue&type=script&lang=js"
export * from "./EditSkill.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__